<template>
	<div class="container">
		<div class="row">
			<div class="col-12">
				<h5>
					Admin <i class="fa fa-chevron-right"></i> Add Poem <span v-if="heading"><i class="fa fa-chevron-right"></i> {{heading}}</span>
				</h5>
				<p v-if="!current_user.admin" class="border-da beware p-5 h4">
					<b><i class="fa fa-warning"></i> Admins Only!!</b>
				</p>
			</div>
		</div>
		<div v-if="current_user.admin" class="row">
			<div class="col-md-8 col-lg-6 mb-5">
				<h3></h3>
				<form v-model="valid" ref="form" lazy-validation class="mb-5">
					<input type="text" maxlength=32 v-model.lazy="heading" :rules="headRules" required placeholder="Heading" class="form-control"/><br>
					<input type="text" maxlength=128 v-model="subheading" placeholder="Sub Heading" class="form-control"/><br>
					<textarea type="text" v-model="body" :rules="bodyRules" rows="10" placeholder="Body" class="form-control">
					</textarea><br>
					<select name="chapter" v-model.number="chapter" class="form-control">
						<option value="" selected="selected">Chapter</option>
						<option value=1>1</option>
						<option value=2>2</option>
						<option value=3>3</option>
						<option value=4>4</option>
					</select><br>
					<div>
						<label for="dn">Date Written</label><input type="text" name="dn" v-model="d8wrtn" class="p-1 ml-2 border-light">
					</div><br>
						<input type="number" min=0 placeholder="Price" v-model.number="price" class="form-control"><br>
					<b @click="submit" :disabled="!valid" class="btn btn-sm border-da">
						Submit
					</b>
					<b @click="clear" class="btn btn-sm border-da ml-1">Clear</b>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';

	export default {
		data: () => ({
			valid: true,
			heading: '',
			subheading: '',
			body: '',
			chapter: '',
			d8wrtn: '',
			price: '',
			headRules: [
				v => !!v || 'Heading is required',
			],
			bodyRules: [
				v => !!v || 'Poem body is required',
			]
		}),
    computed: {
			current_user() {
				return this.$store.getters.fetchUser;
			},
		},
		methods: {
			submit() {
				if (this.$refs.form) {
          const token = window.localStorage.getItem('Bearer');
					return axios({
						method: 'post',
						data: {
							heading: this.heading,
							subheading: this.subheading,
							body: this.body,
							chapter: this.chapter,
							datewritten: this.d8wrtn,
							price: this.price,
						},
						url: '../../api/poem_add',
						headers: {
              'Authorization': `Bearer ${token}`,
							'Content-Type': 'application/json',
						},
					})
					.then((res) => {
          	this.$store.commit('POEM', res.data.poem);
						//this.$router.push({ name: 'Poems' });
      			this.$swal('Poem Added','','success');
						this.clear();
					})
					.catch(() => {
      			this.$swal(
	      			'Poem Could Not Be Added','',
	      			'error'
      			);
					});
				} return true;
			},
			clear() {
				this.$refs.form.reset();
			},
		},
	};
</script>